import {NgModule} from '@angular/core';
import {SanitizePipe, SanitizeType} from './sanitize.pipe';
import {BoldTextPipe} from './bold.text.pipe';
import {UniquePipe} from "./unique.pipe";

@NgModule({
  declarations: [SanitizePipe, BoldTextPipe, UniquePipe],
  exports: [SanitizePipe, BoldTextPipe, UniquePipe],
})
export class CommonPipesModule {
}
